<script setup lang="ts">
import monsterUrl from '/assets/monster.png';
import SpeechBubble from '@/components/SpeechBubble.vue';
import BDetails from '@/components/BDetails.vue';

const color = 'purple';

defineEmits<{
  (e: 'resize'): void;
}>();
</script>

<template>
  <div class="px-8 mt-8 pb-8 w-full overflow-y-auto overflow-x-hidden mb-4">
    <h3 class="m-0 font-light">Nu till dina matvanor.</h3>

    <div class="mb-2">
      <!-- <p class="text-base mt-1 mb-10">
        Det är viktigt att ha balans mellan fysisk aktivitet och kost.
      </p> -->
      <div class="flex justify-center flex-col items-center relative mx-auto">
        <div class="relative flex justify-center items-center">
          <speech-bubble
            :color="color"
            class="w-[200px] md:w-[220px]"
          />

          <div
            class="absolute lg:text-[15px] text-[min(5vw,1.15rem)] text-center w-[70%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          >
          Äter du för lite eller för mycket i förhållande till hur mycket du rör dig?
          </div>
        </div>
        <img class="monster shrink-0 -mt-4" :src="monsterUrl" />
      </div>
<!-- 
      <div class="flex flex-col gap-y-2 mt-4 mb-20">
        <b-details @toggle="$emit('resize')">
          <template #summary>Mitt Energibehov</template>

          <strong>Mitt Energibehov är X kcal</strong> beräknat från din Fysisk
          aktivitet i vardagen på arbetet och ditt stillasittande.
        </b-details>

        <b-details @toggle="$emit('resize')">
          <template #summary>Mitt Energiintag</template>

          <strong>Mitt Energiintag är X kcal</strong> beräknat utifrån dina
          måltidssvar.
        </b-details>
      </div> -->
    </div>
  </div>
</template>

<style scoped lang="postcss">
</style>
